import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import ClientAtsStep from "./ClientAtsStep";
import ClientFeedStep from "./ClientFeedStep";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/v2/form";
import { RadioGroup, RadioGroupCard } from "@/components/ui/v2/radio-group";
import { ClientTypeEnum } from "@/types/client/ClientType";
import { AddClientRequest } from "@/types/request/AddClientRequest";

const ClientTypeStep = () => {
  const { t } = useTranslation();
  const { control, setValue, resetField } =
    useFormContext<AddClientRequest>();
  const clientType = useWatch({ control, name: "clientType" });

  const typeOptions = [
    {
      label: t("common.ATS"),
      value: ClientTypeEnum.ATS,
      description: t("admin.client.addClient.clientType.ATSDescription"),
    },
    {
      label: t("common.feed"),
      value: ClientTypeEnum.FEED,
      description: t("admin.client.addClient.clientType.feedDescription"),
    },
  ];

  const handleTypeChange = (newType: ClientTypeEnum) => {
    setValue("clientType", newType);
    resetField("feedUrl");
  };

  return (
    <>
      <FormField
        control={control}
        name="clientType"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t("admin.client.addClient.clientType.clientType")}
            </FormLabel>
            <FormControl>
              <RadioGroup
                value={field.value}
                onValueChange={(value) =>
                  handleTypeChange(value as ClientTypeEnum)
                }
              >
                {typeOptions.map((option) => (
                  <RadioGroupCard
                    key={option.value}
                    id={`clientType-${option.value}`}
                    value={option.value}
                    label={option.label}
                    description={option.description}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {clientType === ClientTypeEnum.ATS ? <ClientAtsStep /> : <ClientFeedStep />}
    </>
  );
};

export default ClientTypeStep;
